export const updateData = {
    "foodUpdate": "29th June",
    "bedUpdate": "29th June, 00:00 hrs"
};